import React, {
  Component,
  ComponentType,
  ErrorInfo,
  PropsWithChildren,
} from 'react';
import Error from "../Error/InternalErrorPage";

interface ErrorBoundaryProps {
  FallbackComponent?: ComponentType<any>;
  onError?: (error: Error, componentStack: string) => void;
}

interface ErrorBoundaryState {
  error?: Error;
}

class ErrorBoundary extends Component<
  PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  constructor(props: PropsWithChildren<ErrorBoundaryProps>) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }
  /**
   *
   */
  componentDidCatch(error: Error, info: ErrorInfo): void {
    const { onError } = this.props;
    if (onError) {
      try {
        onError(error, info?.componentStack ?? '');
      } catch (error) { /* empty */ }
    }
  }

  render() {
    const { children, FallbackComponent = Error } = this.props;
    const { error } = this.state;
    if (error != null) {
      return <FallbackComponent />;
    }

    return <>{children}</>;
  }
}

export default ErrorBoundary;
